import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const UiDataStudentStatusTypesList = (
    accessToken
) => {
    return useQuery(
        ["ui-data/student-status-types", accessToken],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/ui-data/student-status-types`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la liste des types de status d'un élève!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const UiDataStudentResultTypesList = (
    accessToken
) => {
    return useQuery(
        ["ui-data/student-result-types", accessToken],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/ui-data/student-result-types`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la liste des types de résultat d'un élève!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const UiDataPaymentMethodTypesList = (
    accessToken
) => {
    return useQuery(
        ["ui-data/payment-method-types", accessToken],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/ui-data/payment-method-types`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la liste des types des méthodes de paiement!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const UiDataPaymentStatusTypesList = (
    accessToken
) => {
    return useQuery(
        ["ui-data/payment-status-types", accessToken],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/ui-data/payment-status-types`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la liste des types des status de paiement!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const UiDataPermissionList = (
    accessToken
) => {
    return useQuery(
        ["ui-data/permissions-list", accessToken],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/ui-data/permissions-list`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la liste des permissions!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const UiDataSlotChangeUrgencyTypesList = (accessToken) => {
    return useQuery(
        ["ui-data/slot-change-urgency-types", accessToken],
        async () => {
            const response = await fetch(
                BACKEND_URL + `/api/v1/ui-data/slot-change-urgency-types`,
                {
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                    },
                }
            );
            if (!response.ok) {
                throw new Error("Erreur de récupération des types d'urgence!");
            }
            return response.json();
        }
    );
};

const UiDataSlotChangeStatusTypesList = (accessToken) => {
    return useQuery(
        ["ui-data/slot-change-status-types", accessToken],
        async () => {
            const response = await fetch(
                BACKEND_URL + `/api/v1/ui-data/slot-change-status-types`,
                {
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                    },
                }
            );
            if (!response.ok) {
                throw new Error("Erreur de récupération des statuts de demande!");
            }
            return response.json();
        }
    );
};

const uiDataAPI = {
    UiDataStudentStatusTypesList,
    UiDataStudentResultTypesList,
    UiDataPaymentMethodTypesList,
    UiDataPaymentStatusTypesList,
    UiDataPermissionList,
    UiDataSlotChangeUrgencyTypesList,
    UiDataSlotChangeStatusTypesList,
};

export default uiDataAPI;
